/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StreamResultOfLiveGachaFeedResponse } from '../../models/stream-result-of-live-gacha-feed-response';

export interface GachaServiceLiveGachaFeed2$Params {
}

export function gachaServiceLiveGachaFeed2(http: HttpClient, rootUrl: string, params?: GachaServiceLiveGachaFeed2$Params, context?: HttpContext): Observable<StrictHttpResponse<StreamResultOfLiveGachaFeedResponse>> {
  const rb = new RequestBuilder(rootUrl, gachaServiceLiveGachaFeed2.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StreamResultOfLiveGachaFeedResponse>;
    })
  );
}

gachaServiceLiveGachaFeed2.PATH = '/api/v3/gateway/ws/gacha/live';
